import { useContext, useEffect, useState } from "react";

import { MonthlyBarChart } from "../components/Graph/MonthlyBarChart";
import DashboardService from "../services/api";
import FourBarContainer from "../components/Container/FourBarContainer";
import CardWithTable from "../components/Container/CardWithTable";
import { appContext } from "../Context/AppContext";
import { DateTime } from "luxon";
export const Selfcare = () => {
  const { department , location,fromDate ,toDate,monthValue} = useContext(appContext);
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;
  const [monthlyData, setMonthlyData] = useState([]);
  const [moduleArray, setModuleArray] = useState<any>([]);
  const [blogsArray, setBlogsArray] = useState<any>([]);
  const [total, setTotal] = useState(0);
  const [barData, setBarData] = useState<any>({});
  const calculatePercentage = (total: any, data: any) => {
    const result = [];
    // console.log(total.length);
    // const totalCount = data.reduce((acc:any, item:any) => acc + item.count, 0);
    for (const item of data) {
      const percentage = Math.round((item.count / total) * 100);
      result.push({ name: item._id, percentage });
    }

    return result;
  };

  function getMonthName(dateString: string) {
    const date = DateTime.fromISO(dateString);
    return date.toFormat("MMMM");
  }

  const fetchData = async () => {
    DashboardService.getSelfCareData(access_code,department, location,fromDate,toDate)
      .then((res: any) => {
        const data = res.data;
        setTotal(data.total_users.length);
        setMonthlyData(data.last30DaysCount);
        setBarData({
          bar1: data.blogCount,
          bar2: data.selfCareCount,
          bar3: data.assessmentCount,
          bar4: data.chatCount,
        });
        setModuleArray(calculatePercentage(data.total_users.length, data.selfMapping));
        setBlogsArray(calculatePercentage(data.total_users.length, data.blogMapping));
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    fetchData();
  }, [department,location,fromDate]);
  return (
    <div>
      <h1 style={{ padding: "25px", backgroundColor: "#fff" }}> Self-Help</h1>
      {monthlyData.length > 0 && (
        <div
          style={{
            padding: "0 15px",
            backgroundColor: "#fff",
            marginLeft: "15px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 0",
            }}
          >
            <div style={{ fontSize: "20px" }}>
              No. of employee engaged with chatbot over {monthValue ? `${getMonthName(monthValue)} Month` :"last 30 days"}
            </div>
          </div>
          <div className="chart-container">
            {" "}
            <MonthlyBarChart data={monthlyData} />{" "}
          </div>
        </div>
      )}
      {monthlyData.length > 0 && (
        <div
          style={{
            padding: "0 15px",
            backgroundColor: "#fff",
            marginLeft: "15px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 0",
            }}
          >
            <div style={{ fontSize: "20px" }}>Consultation</div>
          </div>
          {monthlyData.length > 0 && (
            <FourBarContainer
              total={total}
              bar1={barData.bar1}
              bar2={barData.bar2}
              bar3={barData.bar3}
              bar4={barData.bar4}
            />
          )}
        </div>
      )}
      {monthlyData.length > 0 && (
        <div className="card-container">
          <CardWithTable title={"Modules"} data={moduleArray} type={"module"} />
          <CardWithTable title={"Blogs"} data={blogsArray} type={"blog"} />
        </div>
      )}
    </div>
  );
};
// total ={total}
